import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Autoplay } from "swiper/modules";
import { useState } from "react";

import "swiper/css";
import "swiper/css/navigation";

const features = [
  {
    title: "Idea in Motion",
    content: "We help you turn your dream of an app into a working product that people can really use.",
    img: "/images/idea-in-motion.webp",
  },
  {
    title: "Built to Evolve",
    content: "We develop apps that can scale and keep up as your clients' and brand needs vary.",
    img: "/images/built-to-evolve.webp",
  },
  {
    title: "User-First Thinking",
    content: "We focus mainly on gaining experiences that make sense to your clients from the first click.",
    img: "/images/user-first-thinking.webp",
  },
];

const IosFeatures = () => {
  const [swiper, setSwiper] = useState(null);

  return (
    <div className="feedback-2-container">

      <Swiper
        modules={[Pagination, Autoplay]}
        spaceBetween={30}
        slidesPerView={1}
        loop={true}
        speed={1200}
        autoplay={{ delay: 2500 }}
        pagination={{
          el: ".feedback-2__pagination",
          clickable: true,
        }}
        onSwiper={setSwiper}
      >
        {features.map((item, index) => (
          <SwiperSlide key={index}>
            <div className="ios-feature-card card rounded-3">
                <div className="pricing-shape">
                    <img src="/images/pricing-shape.png" alt="image"/>
                </div>
              <div className="card-body p-sm-6 p-md-12 position-relative z-1">
                <div className="mb-4">
                    <img alt="image" className="img-fluid" src={ item.img }/>
                </div>
                <h6 className="mb-4">{ item.title }</h6>

                <p className="mb-6">
                  { item.content }
                </p>

              </div>
            </div>
          </SwiperSlide>
        ))}
      </Swiper>

      <div className="swiper-pagination feedback-2__pagination mt-2 text-start"></div>

    </div>
  );
};

export default IosFeatures;